var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDocumentEconomy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 22H17.5a.5.5 0 010-1h3.25c.689 0 1.25-.561 1.25-1.25s-.561-1.25-1.25-1.25h-1.5c-1.241 0-2.25-1.01-2.25-2.25S18.009 14 19.25 14h3.25a.5.5 0 010 1h-3.25c-.689 0-1.25.561-1.25 1.25s.561 1.25 1.25 1.25h1.5c1.241 0 2.25 1.01 2.25 2.25S21.991 22 20.75 22z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.012 24a.5.5 0 01-.5-.5v-1.793a.5.5 0 011 0V23.5a.5.5 0 01-.5.5zM20.012 15a.5.5 0 01-.5-.5v-2a.5.5 0 011 0v2a.5.5 0 01-.5.5zM15.5 20h-13c-.827 0-1.5-.673-1.5-1.5v-11a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v3.06a.5.5 0 01-1 0V8H2v10.5a.5.5 0 00.5.5h13a.5.5 0 010 1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11h-5a.5.5 0 010-1h5a.5.5 0 010 1zM19.5 8H.5a.5.5 0 01-.5-.5v-4A.5.5 0 01.5 3h19a.5.5 0 01.5.5v4a.5.5 0 01-.5.5zM1 7h18V4H1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 4a.502.502 0 01-.354-.146L16.293 1H3.707L.854 3.854a.5.5 0 01-.707-.707l3-3A.496.496 0 013.5 0h13c.133 0 .26.053.354.146l3 3A.5.5 0 0119.5 4z"
  })));
}

export default SvgDocumentEconomy;